import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import ProductDetail from './ProductDetail';

const QrPage = (props) => {
  const [t, i18n] = useTranslation();
  const code = props.match.params.code
  useEffect(() => {
    console.log("cmd",code)

  }, [code]);
  return (
    <div>
      <ProductDetail code={code}/>
    </div>
  )
}

export default QrPage
